import { View } from "@/components/ui";
import { AnimatedSlideView } from "@/components/shared/animated-slide-view";
import type { IntervalScrollVerticalProps } from "./types";
import { useIntervalScrollVertical } from "./use-interval-scroll-vertical.web";

export function IntervalScrollVertical<T>({
  items,
  renderItem,
  intervalMs,
  scrollDurationMs,
  viewportHeight,
  enabled = true,
  className,
  style,
}: IntervalScrollVerticalProps<T>) {
  const scroll = useIntervalScrollVertical({
    itemCount: items.length,
    intervalMs,
    scrollDurationMs,
    viewportHeight,
    enabled,
  });

  const transitionStyle = `transform ${scroll.transitionDurationSec}s ease-in-out`;

  return (
    <View
      className={className ?? "relative flex min-w-0 flex-1 overflow-hidden"}
      style={{ height: scroll.viewportHeight, ...style }}
    >
      {scroll.isTransitioning ? (
        <>
          <AnimatedSlideView
            style={{
              position: "absolute",
              left: 0,
              right: 0,
              top: 0,
              height: scroll.viewportHeight,
              display: "flex",
              flexDirection: "row",
              gap: 8,
              transform: scroll.transitionToEnd
                ? "translateY(100%)"
                : "translateY(0)",
              transition: transitionStyle,
            }}
            onTransitionEnd={
              scroll.transitionToEnd ? scroll.handleTransitionEnd : undefined
            }
          >
            {renderItem(items[scroll.index])}
          </AnimatedSlideView>
          <AnimatedSlideView
            style={{
              position: "absolute",
              left: 0,
              right: 0,
              top: 0,
              height: scroll.viewportHeight,
              display: "flex",
              flexDirection: "row",
              gap: 8,
              transform: scroll.transitionToEnd
                ? "translateY(0)"
                : "translateY(-100%)",
              transition: transitionStyle,
            }}
          >
            {renderItem(items[scroll.nextIndex])}
          </AnimatedSlideView>
        </>
      ) : (
        <View
          className="flex h-full flex-row gap-2"
          style={{ height: scroll.viewportHeight }}
        >
          {renderItem(items[scroll.index])}
        </View>
      )}
    </View>
  );
}
